import { catchError, map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { Observable, of, throwError } from "rxjs";
import { HttpCemex, CmxHttpOptions } from "@cemex-core/angular-services-v8";

import { Parameter, ParameterGroup } from "./../models/parameter.model";
import { EndpointService } from "./../../services/helpers/endpoint.service";

@Injectable()
export class ParametersService {
  constructor(private http: HttpCemex, private endpointService: EndpointService) {
    //
  }

  /**
   * @description /countryparameters Get the parameters list of a specific country.
   * @param countryCode The code of a country.
   * @param [parameterGroup] Optional parameter for requesting a specific parameter group.
   * @returns Observable
   */
  public getCountryParameterGroups(countryCode: string, parameterGroup?: string): Observable<ParameterGroup[]> {
    const endpoint = this.endpointService.getUrl("v2", "rc", "countryparameters");

    const options = {
      params: {
        countryCode: countryCode?.trim() ?? "",
        parameterGroup: parameterGroup ?? "",
      },
    } as CmxHttpOptions;

    return this.http.get(endpoint, options).pipe(
      map((response: any) => {
        const aux: ParameterGroup[] = response;
        return aux;
      }),
      catchError((error: any) => throwError(error.error || "Request from Server error"))
    );
  }

  /**
   * @description /countryparameters Get the parameters list of a specific country.
   * @param countryCode The code of a country.
   * @returns Observable
   */
  public getCountryParameters(countryCode: string): Observable<Parameter[]> {
    if (!countryCode) {
      return of([] as Parameter[]);
    }
    const endpoint = this.endpointService.getUrl("v2", "rc", "countryparameters");
    const options = {
      params: {
        countryCode: countryCode.trim(),
      },
    } as CmxHttpOptions;

    return this.http.get(endpoint, options).pipe(
      map((response: ParameterGroup[]) => {
        const aux: ParameterGroup[] = response;
        let parameters: Parameter[] = [];
        aux.forEach((group) => (parameters = parameters.concat(group.parameters)));
        return parameters;
      }),
      catchError((error: any) => throwError(error.error || "Request from Server error"))
    );
  }

  /**
   * @description /customerparameters Get the parameters list of a specific customer.
   * @param customerCode The code of a customer or legalEntity.
   * @param countryCode The code of a country.
   * @returns Observable
   */
  public getCustomerParameterGroups(customerCode: string, countryCode: string): Observable<ParameterGroup[]> {
    const endpoint = this.endpointService.getUrl("v2", "rc", "customerparameters");

    const options = {
      params: {
        countryCode: countryCode?.trim() ?? "",
        customerCode: customerCode ?? "",
      },
    } as CmxHttpOptions;

    return this.http.get(endpoint, options).pipe(
      map((response: any) => {
        const aux: ParameterGroup[] = response;
        return aux;
      }),
      catchError((error: any) => throwError(error.error || "Request from Server error"))
    );
  }
}

// @Injectable()
// export class CountryConfigurationService {
//     private apiCountryParameters: string;
//     private apiCountryList: string;
//     private apiPaymentMethods: string;
//     params$: EventEmitter<any> = new EventEmitter();

//     constructor(private http: HttpCemex, private endpoint: EndpointsConstants) {
//         this.apiCountryParameters = "countryparameters";
//         this.apiCountryList = "countrieslist";
//         this.apiPaymentMethods = "paymentmethods";
//     }

//     private getUrl(api: string): string {
//         return this.endpoint.getBasePath() + this.endpoint.V2 + this.endpoint.rcCapability + api;
//     }

//     getCountryList(): Promise<Array<countryList>> {
//         return this.http.get(this.getUrl(this.apiCountryList)).toPromise()
//             .then(response => {
//                 return response;
//             })
//             .catch(error => {
//                 return error;
//             });
//     }

//     getPaymentMethods(): Promise<Array<paymentMethod>> {
//         return this.http.get(this.getUrl(this.apiPaymentMethods)).toPromise()
//             .then(response => {
//                 return response;
//             })
//             .catch(error => {
//                 return error;
//             });
//     }

//     saveConfigurationCountry(countryParameters: any) {
//         return this.http.post(this.getUrl(this.apiCountryParameters), countryParameters).toPromise()
//             .then(response => {
//                 return Promise.resolve();
//             }
//             ).catch(error => {
//                 return Promise.reject(error);
//             }
//             );
//     }

//     editConfigurationCountry(countryParameters: any) {
//         return this.http.put(this.getUrl(this.apiCountryParameters), countryParameters).toPromise()
//             .then(response => {
//                 return Promise.resolve();
//             }
//             ).catch(error => {
//                 return Promise.reject(error);
//             }
//             );
//     }

//     deleteConfigurationCountry(params: any) {
//         return this.http.put(this.getUrl(this.apiCountryParameters), params).toPromise()
//             .then(response => {
//                 return Promise.resolve();
//             }
//             ).catch(error => {
//                 return Promise.reject(error);
//             }
//             );
//     }

// }
